import { Controller } from "@hotwired/stimulus"

// Doble confirmación V2 para acciones destructivas en masa: el submit del
// formulario llega deshabilitado del HTML y solo se habilita cuando el texto
// tipeado coincide con la palabra esperada ("eliminar" / "delete"), que viaja
// por i18n en un data-value. Comparación sin case ni espacios de punta: la
// barrera es la atención de quien confirma, no la memoria de un string.
//
// Sin confirm() nativo ni estado fuera del DOM: el atributo `disabled` es el
// estado, y Turbo lo restaura del HTML en cada repintado por morph.
export default class extends Controller {
  static targets = ["input", "submit"]
  static values = { expected: String }

  check() {
    const typed = this.inputTarget.value.trim().toLowerCase()
    this.submitTarget.disabled = typed !== this.expectedValue.trim().toLowerCase()
  }
}
